module.exports = __webpack_public_path__ + "img/whatsapp_white.84000311.svg";